<template>
  <div class="col-xs-12 col-md-3">
    <form-group-input
      ref="input"
      type="number"
      min="1"
      max="9999"
      step="1"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="options"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  name: "c-protocolo-number-curto",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    options() {
      let options = [];
      for (let i = 0; i < 10; i++) {
        options = [
          ...options,
          {
            value: this.$moment().format("YYYY") - i,
            text: this.$moment().format("YYYY") - i
          }
        ];
      }
      return options;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/NumberCurto.vue